import { pinVirtual } from "../../components/generico/utils/UrlAPI"; 
import AuthService from "../login/auth.service";
import axios from "axios";

class PinVirtualService {

    async obtenerToken(data){
        let url = pinVirtual + 'pinVirtual/obtenerToken';
        let config = {
            method : 'post',
            url : url,
            headers:{
                'Content-Type' : 'application/json',
                Authorization : 'Bearer '+ AuthService.getCurrentToken()
            },
            data : data,
            timeout: 100000
        }
        return await axios(config);
    }

    async validarEstadoTarjeta(data){
        let url = pinVirtual+'pinVirtual/validarEstadoTarjeta';
        let config = {
            method : 'post',
            url : url,
            headers : {
                'Content-Type' : 'application/json',
                Authorization : 'Bearer ' + AuthService.getCurrentToken()
            },
            data : data, 
            timeout: 100000
        }
        return await axios(config);
    }

    async validarPinIngresado(data){
        let url = pinVirtual + 'pinVirtual/validarPinIngresado';
        let config = {
            method : 'post',
            url : url,
            headers : {
                'Content-Type' : 'application/json',
                Authorization : 'Bearer ' + AuthService.getCurrentToken()
            },
            data : data,
            timeout: 100000
        }
        return await axios(config);
    }

    async actualizarPin(data){
        let url = pinVirtual + 'pinVirtual/actualizarPin';
        let config = {
            method : 'post',
            url : url,
            headers : {
                'Content-Type' : 'application/json',
                Authorization : 'Bearer ' + AuthService.getCurrentToken()
            },
            data : data,
            timeout: 100000
        }
        return await axios(config);
    }

}
export default new PinVirtualService();